import React from 'react';
import Modal from '../../../../../component/modals/modal';
import MilestoneModal from '../../../../../component/modals/milestoneModal';
import DeleteModal from '../../../../../component/modals/deleteModal';
import CreateTaskModalV2 from '../../../../../component/modals/createTaskModal';
import ConfirmationModal from '../../../../../component/modals/confirmationModal';
import { TaskModel } from '../../../../../mobx/models/task';
import { Milestone as MilestoneType } from '../../../../../mobx/interfaces/project';

interface MilestoneModalsProps {
  // Milestone Modal
  isOpenMilestoneModal: boolean;
  closeMilestoneModal: () => void;
  projectId: string;
  selectedMilestone: MilestoneType | null;

  // Delete Modal
  deleteModelOpen: boolean;
  closeDeleteModal: () => void;
  onDeleteMilestone: () => void;
  buttonLoading: boolean;

  // Archive Modal
  archiveModelOpen: boolean;
  closeArchiveModal: () => void;
  onArchiveMilestone: () => void;

  // Create Task Modal
  open: boolean;
  handleCancel: () => void;
  loadData: () => void;

  // Task Delete Modal
  taskDeleteModelOpen: boolean;
  onDeleteModalClose: () => void;
  selectedItem: TaskModel | undefined;
  deleteTask: (task: TaskModel) => void;
  deleteLoading?: boolean;

  // Confirmation Modal
  confirmationModelOpen: boolean;
  closeConfirmationModal: () => void;
  confirmationLoading: boolean;
  onClickConfirm: () => void;
  onClickNo: () => void;
}

const MilestoneModals: React.FC<MilestoneModalsProps> = ({
  isOpenMilestoneModal,
  closeMilestoneModal,
  projectId,
  selectedMilestone,
  deleteModelOpen,
  closeDeleteModal,
  onDeleteMilestone,
  buttonLoading,
  archiveModelOpen,
  closeArchiveModal,
  onArchiveMilestone,
  open,
  handleCancel,
  loadData,
  taskDeleteModelOpen,
  onDeleteModalClose,
  selectedItem,
  deleteTask,
  deleteLoading,
  confirmationModelOpen,
  closeConfirmationModal,
  confirmationLoading,
  onClickConfirm,
  onClickNo
}) => {
  return (
    <>
      <Modal open={isOpenMilestoneModal} onClose={closeMilestoneModal} maxWidth={'462px'}>
        <MilestoneModal onClose={closeMilestoneModal} projectId={projectId} milestone={selectedMilestone} />
      </Modal>
      <Modal open={deleteModelOpen} onClose={closeDeleteModal} maxWidth={'334px'}>
        <DeleteModal
          onClose={closeDeleteModal}
          onOk={onDeleteMilestone}
          modalTitle='Delete Milestone?'
          description='Are you sure you want to delete this milestone?'
          loading={buttonLoading}
        />
      </Modal>
      <Modal open={archiveModelOpen} onClose={closeArchiveModal} maxWidth={'334px'}>
        <DeleteModal
          onClose={closeArchiveModal}
          onOk={onArchiveMilestone}
          modalTitle='Archive Milestone?'
          description='Are you sure you want to archive this milestone?'
          isArchive={true}
          loading={buttonLoading}
        />
      </Modal>
      <Modal open={open} onClose={handleCancel} isCreateTask={true} maxWidth={'680px'}>
        <CreateTaskModalV2 loadData={loadData} onCancel={handleCancel} />
      </Modal>
      <Modal open={taskDeleteModelOpen} onClose={onDeleteModalClose} maxWidth={'334px'}>
        <DeleteModal
          onClose={onDeleteModalClose}
          onOk={() => selectedItem && deleteTask(selectedItem)}
          loading={deleteLoading}
          modalTitle='Delete Task?'
          description='Are you sure you want to delete this task?'
        />
      </Modal>
      <Modal open={confirmationModelOpen} onClose={closeConfirmationModal} maxWidth={'334px'}>
        <ConfirmationModal
          loading={confirmationLoading}
          cancelLoading={false}
          onOk={onClickConfirm}
          onNo={onClickNo}
          onClose={closeConfirmationModal}
          modalTitle='Uncompleted Subtasks'
          description='Do you want to complete all these subtasks?'
        />
      </Modal>
    </>
  );
};

export default MilestoneModals;
